.disclaimerContainer {
	display: flex;
	flex-direction: column;
	gap: 0.9375rem;
}

.disclaimerLink:global(.MuiTypography-root) {
	font-size: 0.9375rem;
	color: #6b6b6b;
	font-weight: 400;
	line-height: 1.6;
}
